<script>
    import { collection, onSnapshot, query, where, orderBy } from "firebase/firestore";
    import { db } from "../../firebase/firestore";
    import { cardsStore, user } from "../../firebase/auth";
    import { offsetDate } from "../../utils/utils";
    import { Route, Router } from "svelte-routing";
    import Cards from "./Cards.svelte";
    import Card from "./Card.svelte";

    const cardSettingsRef = collection(db, "cardSettings");
    const q = query(cardSettingsRef, where("owner", "==", $user.uid), orderBy("start"));

    let cards;
    let blocked;

    const unsub = onSnapshot(q, (querySnapshot) => {
        cards = [];
        blocked = {}
        querySnapshot.forEach((doc) => {
            const aCard = doc.data();
            aCard.id = doc.id;
            cards.push(aCard);
            blocked[doc.id] = ({start: aCard.start.toDate(), end: offsetDate(aCard.end.toDate(), -1)})
        });
        cards = cards;
        blocked = blocked;
    });
</script>

<Router>
    <Route path="/">
        <Cards cards={cards} bind:blocked/>
    </Route>
    <Route path="/:id" let:params>
        <Card id={params.id} bind:blocked/>
    </Route>
</Router>
